import { DESCRIPCION_CONFIANZA, type ConfianzaCosto } from '@/domain/costing';

const ESTILOS: Readonly<Record<ConfianzaCosto, { clases: string; icono: string; texto: string }>> = {
  firme: {
    clases: 'bg-exito-suave text-texto border-exito/40',
    icono: '✓',
    texto: 'Costo firme',
  },
  estimado: {
    clases: 'bg-aviso-suave text-texto border-aviso/40',
    icono: '≈',
    texto: 'Costo estimado',
  },
  incompleto: {
    clases: 'bg-alerta-suave text-texto border-alerta/40',
    icono: '!',
    texto: 'Costo incompleto',
  },
};

/**
 * Sello que dice que tan firme es la cifra.
 *
 * Lleva icono y texto ademas de color, para no depender solo del color
 * (Req. 19.7). Un numero de costo sin esta marca puede llevar a fijar un precio
 * sobre informacion incompleta.
 */
export function SelloConfianza({ confianza }: { confianza: ConfianzaCosto }) {
  const { clases, icono, texto } = ESTILOS[confianza];

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${clases}`}
      title={DESCRIPCION_CONFIANZA[confianza]}
    >
      <span aria-hidden="true">{icono}</span>
      {texto}
    </span>
  );
}
